import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';
import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';

export const eventCreate: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('group.header.create-event') as string;
			},
			trappRoute(to: Route): string {
				return `/dvf.shtml?pd=${to.params.groupId}`;
			},
		},
		path: 'events',
		name: Routes.GROUP_ADMIN_EVENT_CREATE,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				groupId: route.params.groupId,
			};
		},
		component: () => import(/* webpackChunkName: "group-admin" */ '@front-app/views/home/group/admin/Events.vue'),
	},
];
